export const selectIsLoading = (state) => state.network.loading;
export const selectNetworkRequests = (state) =>
  state.network.networkRequests;

export const selectLastError = (state) =>
  state.network.lastError;
